import { regexEmail } from 'mailup-react-helpers'
import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText
} from 'mailup-web-components'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { stepState } from 'Pages/Campaign/recoil/state/page'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const InputSenderReplyTo = () => {
  const intl = useIntl()

  const [
    {
      EmailOptions: { ReplyTo }
    },
    setCampaignState
  ] = useRecoilState(campaignState)

  const [
    {
      step3: {
        senderInfo: { replyToIsDirty, replyToIsInvalid }
      }
    },
    setStepState
  ] = useRecoilState(stepState)

  const handleChangeReplyTo = (e) => {
    const email = e.target.value
    setCampaignState((prev) => ({
      ...prev,
      isDirty: true,
      EmailOptions: {
        ...prev.EmailOptions,
        ReplyTo: email
      }
    }))

    setStepState((prev) => ({
      ...prev,
      step3: {
        ...prev.step3,
        senderInfo: {
          ...prev.step3.senderInfo,
          replyToIsDirty: true,
          replyToIsInvalid: !email.match(regexEmail)
        }
      }
    }))
  }

  return (
    <div>
      <>
        <FormElement
          required
          label={intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
          feedback={
            ReplyTo === '' && replyToIsDirty
              ? intl.formatMessage({
                  id: 'Load.EmailSendingWizard.SenderNameRequired'
                })
              : replyToIsInvalid && replyToIsDirty
                ? intl.formatMessage({ id: 'Load.Common.WrongFormatWarning' })
                : undefined
          }
        >
          <InputText
            value={ReplyTo}
            onChange={handleChangeReplyTo}
            variant={
              (ReplyTo === '' || replyToIsInvalid) && replyToIsDirty
                ? INPUT_TEXT_VARIANT_DANGER
                : null
            }
            data-mu-test='campaign-wizard-input-ReplyTo'
          />
        </FormElement>
      </>
    </div>
  )
}

export default InputSenderReplyTo
